import {Component, Input} from '@angular/core';

@Component({
    selector: 'card-block',
    templateUrl: './conditional-block.component.html',
    standalone: false
})

export class ConditionalBlockComponent {
  @Input() condition: boolean;
  @Input() errorText: string;
}
